// Configuration centralisée des URLs API
const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://ats030825.onrender.com';

export const API_ENDPOINTS = {
  // Base URL
  BASE: API_BASE_URL,
  
  // Authentification
  LOGIN: `${API_BASE_URL}/api/users/login`,
  
  // Entreprise
  COMPANY_INFO: `${API_BASE_URL}/api/myCompanyInfo`,
  COMPANY_LOGO: `${API_BASE_URL}/api/upload/logo`,
  COMPANY_STAMP: `${API_BASE_URL}/api/upload/stamp`,
  COMPANY_STAMP_UPDATE: (id) => `${API_BASE_URL}/api/myCompanyInfo/stamp/${id}`,
  
  // Transporteurs
  TRANSPORTEURS: `${API_BASE_URL}/api/transporteurs`,
  TRANSPORTEUR_DELETE: (id) => `${API_BASE_URL}/api/transporteurs/delete/${id}`,
  
  // Clients (anciennement transporteurs)
  CLIENTS: `${API_BASE_URL}/api/clients`,
  CLIENT_DELETE: (id) => `${API_BASE_URL}/api/clients/delete/${id}`,
  
  // Clients
  LISTE_CLIENTS: `${API_BASE_URL}/api/listeClients`,
  LISTE_CLIENT_DELETE: (id) => `${API_BASE_URL}/api/listeClients/delete/${id}`,
  
  // Commissionnaires
  COMMISSIONNAIRES: `${API_BASE_URL}/api/listeCommissionnaire`,
  
  // Devis
  ESTIMATES: `${API_BASE_URL}/api/estimate`,
  ESTIMATE_DELETE: (id) => `${API_BASE_URL}/api/estimate/delete/${id}`,
  
  // Factures
  INVOICES: `${API_BASE_URL}/api/invoice`,
  
  // Ordres de transport
  TRANSPORT_ORDERS: `${API_BASE_URL}/api/transportOrder`,
  TRANSPORT_ORDER_DELETE: (id) => `${API_BASE_URL}/api/transportOrder/delete/${id}`,
  TRANSPORT_ORDER_UPDATE: (id) => `${API_BASE_URL}/api/transportOrder/update/${id}`,
  TRANSPORT_ORDER_ADD: `${API_BASE_URL}/api/transportOrder/add`,
  
  // Conditions de transport
  TRANSPORT_CONDITIONS: `${API_BASE_URL}/api/conditionsTransport`,
  TRANSPORT_CONDITIONS_UPDATE: (id) => `${API_BASE_URL}/api/conditionsTransport/update/${id}`,
  TRANSPORT_CONDITIONS_ADD: `${API_BASE_URL}/api/conditionsTransport/add`,
  TRANSPORT_CONDITIONS_DELETE: (id) => `${API_BASE_URL}/api/conditionsTransport/delete/${id}`,
  
  // Messages
   MESSAGES: `${API_BASE_URL}/api/receivedMessage`,
   MESSAGE_ADD: `${API_BASE_URL}/api/receivedMessage/add`,
   MESSAGE_DELETE: (id) => `${API_BASE_URL}/api/receivedMessage/delete/${id}`,
  
  // Notes
  NOTES: (userId) => `${API_BASE_URL}/api/notes/${userId}`,
  
  // Utilisateurs
  USERS: `${API_BASE_URL}/api/users`,
  
  // Upload
  UPLOAD_FETCH_LOGO: `${API_BASE_URL}/api/upload/fetch-logo`,
};

export default API_ENDPOINTS; 